module.exports = __webpack_public_path__ + "img/BS24_znzd.4a061167.png";